import _ from 'lodash'
import type { DomApplier } from '../cssFeatures.types'
import type { SelectorObj } from '../../shared.types'
import type { ZIndexCss, ZIndexCssPage } from './zIndexCss.types'

export const zIndexCssDomApplier: DomApplier<'zIndexCss'> = (__, ___, ____, zIndexCssDetails, _____) => {
	if (!zIndexCssDetails || !zIndexCssDetails.defaultZIndexCss || zIndexCssDetails.defaultZIndexCss?.component) {
		return null
	}
	const { defaultZIndexCss } = zIndexCssDetails as { defaultZIndexCss: ZIndexCssPage }
	const acc: SelectorObj = {}

	_(defaultZIndexCss).forEach((zIndexDetails, selector) => {
		acc[`#${selector}`] = zIndexDetails as ZIndexCss
	})
	return acc
}
